import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CreditosService } from 'src/app/creditos/servicios/creditos.service';
import { Utilerias } from 'src/app/utilerias/clases-globales/utilerias';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-credenciales-not',
  templateUrl: './modal-credenciales.component.html',
  styles: [],
  standalone: false,
})
export class ModalCredencialesComponent implements OnInit {

  mostrarMascara: boolean;
  /**
   * **********************************************************************************************
   * BEGIN  Angular
   * **********************************************************************************************.
   */

  constructor(

    public dialogRef: MatDialogRef<ModalCredencialesComponent>,
    private msg: Msg,
    private creditoService: CreditosService, private utilerias: Utilerias) {
  }

  @ViewChild('password') txtPass: ElementRef;
  @ViewChild('usuario') txtUser: ElementRef;

  ngOnInit() {
    this.mostrarMascara = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSignin(form: NgForm) {
    const usuario = form.value.usuario;
    const password = form.value.password;

    if (usuario === '') {
      Swal.fire({
        title: 'Datos Inválidos',
        text: 'Favor de ingresar su nombre de usuario...',
        icon: 'warning',
      });
      this.txtUser.nativeElement.focus();
      return;
    } else if (password === '') {
      Swal.fire({
        title: 'Datos Inválidos',
        text: 'Favor de ingresar su contraseña...',
        icon: 'warning',
      }).then(reason => {
        this.txtPass.nativeElement.focus();
      });
      return;
    }
    this.mostrarMascara = true;
    this.creditoService.validaCredenciales(usuario, password).subscribe(response => {
      if (this.validarRespuesta(response)) {
        this.dialogRef.close(response);
      }
      this.mostrarMascara = false;
    }, () => {
      this.mostrarMascara = false;
    });
  }

  validarRespuesta(response: any): boolean {
    if (!this.utilerias.validarObjecto(response)) {
      this.msg.warningCall("Credenciales Inválidas", "Error", null);
      return false;
    }
    return true;
  }

}
